import _ from 'lodash-es'

import { storageNamespace } from '~/helpers/storage-namespaces'

/* ================ SECTIONS ================*/
window.theme = window.theme || {}
window.mint = window.mint || {}

/**
 * Define empty functions here, as mint.EventBus won't have been defined
 * when this file gets called. Once it does become defined it'll get overwritten.
 */
window.mint.EventBus = window.mint.EventBus || {}
// window.mint.EventBus.on = function() { /* Empty. */ };

theme.Cart = (function() {
  const selectors = {
    cartDiscount: '[data-cart-discount]',
    cartDiscountTitle: '[data-cart-discount-title]',
    cartDiscountAmount: '[data-cart-discount-amount]',
    cartDiscountWrapper: '[data-cart-discount-wrapper]',
    cartErrorMessage: '[data-cart-error-message]',
    cartErrorMessageWrapper: '[data-cart-error-message-wrapper]',
    cartItem: '[data-cart-item]',
    cartItemDetails: '[data-cart-item-details]',
    cartItemDiscount: '[data-cart-item-discount]',
    cartItemDiscountedPriceGroup: '[data-cart-item-discounted-price-group]',
    cartItemDiscountTitle: '[data-cart-item-discount-title]',
    cartItemDiscountAmount: '[data-cart-item-discount-amount]',
    cartItemDiscountList: '[data-cart-item-discount-list]',
    cartItemFinalPrice: '[data-cart-item-final-price]',
    cartItemImage: '[data-cart-item-image]',
    cartItemLinePrice: '[data-cart-item-line-price]',
    cartItemOriginalPrice: '[data-cart-item-original-price]',
    cartItemPrice: '[data-cart-item-price]',
    cartItemPriceList: '[data-cart-item-price-list]',
    cartItemProperty: '[data-cart-item-property]',
    cartItemPropertyName: '[data-cart-item-property-name]',
    cartItemPropertyValue: '[data-cart-item-property-value]',
    cartItemRegularPriceGroup: '[data-cart-item-regular-price-group]',
    cartItemRegularPrice: '[data-cart-item-regular-price]',
    cartItemTitle: '[data-cart-item-title]',
    cartItemOption: '[data-cart-item-option]',
    cartLineItems: '[data-cart-line-items]',
    cartQuantityErrorMessage: '[data-cart-quantity-error-message]',
    cartQuantityErrorMessageWrapper:
      '[data-cart-quantity-error-message-wrapper]',
    cartRemove: '[data-cart-remove]',
    cartStatus: '[data-cart-status]',
    cartSubtotal: '[data-cart-subtotal]',
    cartTableCell: '[data-cart-table-cell]',
    cartWrapper: '[data-cart-wrapper]',
    emptyPageContent: '[data-empty-page-content]',
    quantityInput: '[data-quantity-input]',
    quantityInputDesktop: '[data-quantity-input-desktop]',
    quantityLabelDesktop: '[data-quantity-label-desktop]',
    thumbnails: '.cart__image',
    termsConditions: '[data-terms-conditions]',
    updateCartPC: '[data-cart-pc]',
    updateCartMB: '[data-mobile-cart]',
  }

  const classes = {
    cartNoCookies: 'cart--no-cookies',
    cartRemovedProduct: 'cart__removed-product',
    hide: 'hide',
    inputError: 'input--error',
  }

  const attributes = {
    cartItemIndex: 'data-cart-item-index',
    cartItemKey: 'data-cart-item-key',
    cartItemQuantity: 'data-cart-item-quantity',
    cartItemTitle: 'data-cart-item-title',
    cartItemUrl: 'data-cart-item-url',
    quantityItem: 'data-quantity-item',
    cartItemVariantId: 'data-variant-id',
    cartItemProductId: 'data-product-id',
  }

  theme.breakpoints = theme.breakpoints || {}

  if (
    isNaN(theme.breakpoints.medium) ||
    theme.breakpoints.medium === undefined
  ) {
    theme.breakpoints.medium = 768
  }

  const mediumUpQuery = '(min-width: ' + theme.breakpoints.medium + 'px)'

  function Cart(container) {
    this.$container = $(container)
    this.$thumbnails = $(selectors.thumbnails, this.$container)

    this.cartData = {}

    if (!this.cookiesEnabled()) {
      this.$container.addClass(classes.cartNoCookies)
    }

    this.$container.on(
      'click',
      selectors.thumbnails,
      this._handleThumbnailClick,
    )

    this.$container.on(
      'change',
      selectors.quantityInput,
      this._handleInputQty.bind(this),
    )

    this.mql = window.matchMedia(mediumUpQuery)

    this.mql.addListener(this.setQuantityFormControllers.bind(this))
    this.setQuantityFormControllers()

    /**
     * Override 'Remove' button in order to hook into Bloomreach.
     */
    this.$container.on(
      'click',
      selectors.cartRemove,
      this._onRemoveItem.bind(this),
    )

    this._cartTermsConditions()

    this._cartCountDown()

    const _ = this

    /**
     * Custom EventBus.
     * - Emulate legacy functions with new dynamic cart.
     */
    mint.EventBus.on('mint:cart:updated', response => {
      this.cartData = response

      /**
       * On cart update, emit events to Bloomreach.
       * - If the user changes 'Size' in components/cart.js, this
       *   storage item is created. Proceed with this event
       *   before doing anything else.
       */
      mint.EventBus.on('bloomreach:ready', () => {
        const optionChange =
          JSON.parse(sessionStorage.getItem(storageNamespace.cartUpdateSize)) ||
          false

        if (optionChange) {
          this._handleBloomreachSizeChange(optionChange)
        }
      })

      /**
       * Continue with normal scenarios.
       * - Do not open Cart Drawer in these scenarios.
       */
      const preventEvents = [
        'cart:addFailed',
        'cart:cleared',
        'cart:clearFailed',
        'cart:fetch',
        'cart:removeFailed',
        'cart:updateAttributes',
        'cart:updateAttributesFailed',
      ]

      if (
        preventEvents.includes(response.request.event) ||
        response.request?.preventDrawer ||
        mint.request.pageType === 'cart'
      ) {
        return
      }

      /**
       * Recreate existing functionality using new EventBus.
       */
      if (response.item_count === 0) {
        _._emptyCart()
      } else {
        _._createCart(response)
        theme.HaloAddOn.progressBarShipping()
      }

      theme.HaloAddOn.removeLoadingPopup()
    })

    $(document).on('click', selectors.updateCartPC, function() {
      theme.HaloAddOn.loadingPopup()

      $.getJSON(mint.routes.cart.endpoint).then(
        function(cart) {
          if (cart.item_count === 0) {
            _._emptyCart()
            theme.HaloAddOn.removeLoadingPopup()
          } else {
            _._createCart(cart)
            theme.HaloAddOn.progressBarShipping()
            theme.HaloAddOn.removeLoadingPopup()
          }
        }.bind(this),
      )
    })

    $(document).on('click', selectors.updateCartMB, function() {
      theme.HaloAddOn.loadingPopup()

      $.getJSON(mint.routes.cart.endpoint).then(
        function(cart) {
          if (cart.item_count === 0) {
            _._emptyCart()

            theme.HaloAddOn.removeLoadingPopup()
          } else {
            _._createCart(cart)
            theme.HaloAddOn.progressBarShipping()
            theme.HaloAddOn.removeLoadingPopup()

            const currentState = window.theme.EventBus.all().state
            if (currentState !== undefined) {
              return
            }

            window.theme.EventBus.emit('cart:added')
          }
        }.bind(this),
      )
    })
  }

  Cart.prototype = _.assignIn({}, Cart.prototype, {

    /**
     * User has changed 'Size' option, emit to Bloomreach.
     * @param {String} key - Line Item key
     * @param {Number|String} productId - Product ID
     */
    _handleBloomreachSizeChange({ productId }) {
      if (!this.cartData?.items) {
        return
      }

      let data = this._getBloomreachCartPayload('optionChange')

      const matchingLineItem = this.cartData?.items?.find(item => {
        return Number(item.product_id) === Number(productId)
      })

      if (!matchingLineItem) {
        return
      }

      const modified = {
        price: Number(matchingLineItem.price / 100),
        product_id: Number(matchingLineItem.product_id),
        quantity: Number(matchingLineItem.quantity),
        variant_id: Number(matchingLineItem.variant_id),
      }

      data = {
        action: 'size change',
        ...data,
        ...modified,
      }

      mint.EventBus.dispatch('bloomreach:trackEvent', {
        event: 'cart_update_web',
        data,
      })

      sessionStorage.removeItem(storageNamespace.cartUpdateSize)
    },

    _handleInputQty: function(evt) {
      evt.preventDefault()

      const $input = $(evt.target)
      const itemIndex = $input.data('quantity-item')
      const $itemElement = $input.closest(selectors.cartItem)
      const $itemQtyInputs = $('[data-quantity-item=' + itemIndex + ']')
      const value = parseInt($input.val())
      const isValidValue = !(value < 0 || isNaN(value))
      $itemQtyInputs.val(value)

      this._hideCartError()
      this._hideQuantityErrorMessage()

      /**
       * Intercept event to emit payload to Bloomreach.
       */
      if (isValidValue && mint.services.bloomreach) {
        const lineItemKey = $input[0]?.id.replace('updates_large_', '') || ''

        let data = this._getBloomreachCartPayload(
          'quantity',
          lineItemKey,
          value,
        )

        const matchingLineItem = this.cartData?.items?.find(item => {
          return item.key === lineItemKey
        })

        const modified = {
          price: Number(matchingLineItem.price / 100),
          product_id: Number(matchingLineItem.product_id),
          quantity: Number(value),
          variant_id: Number(matchingLineItem.variant_id),
        }

        const quantityDifference =
          modified.quantity - matchingLineItem.quantity
        const totalPrice =
          data.total_price + modified.price * quantityDifference

        data = {
          action: 'quantity change',
          ...data,
          ...modified,
          total_price: totalPrice,
        }

        mint.EventBus.dispatch('bloomreach:trackEvent', {
          event: 'cart_update_web',
          data,
        })
      }

      if (!isValidValue) {
        this._showQuantityErrorMessages($itemElement)
        return
      }
    },

    _createCart: function(state) {
      const cartDiscountList = this._createCartDiscountList(state)

      $(selectors.emptyPageContent).addClass(classes.hide)
      $(selectors.cartWrapper).removeClass(classes.hide)
      $(selectors.cartLineItems, this.$container).html(
        this._createLineItemList(state),
      )

      this.setQuantityFormControllers()

      if (cartDiscountList.length === 0) {
        $(selectors.cartDiscountWrapper, this.$container)
          .html('')
          .addClass(classes.hide)
      } else {
        $(selectors.cartDiscountWrapper, this.$container)
          .html(cartDiscountList)
          .removeClass(classes.hide)
      }

      $(selectors.cartSubtotal, this.$container).html(
        theme.Currency.formatMoney(
          state.total_price,
          theme.moneyFormatWithCurrency,
        ),
      )
    },

    _createCartDiscountList: function(cart) {
      return $.map(
        cart.cart_level_discount_applications,
        function(discount) {
          const $discount = this.$cartDiscountTemplate.clone()
          $discount.find(selectors.cartDiscountTitle).text(discount.title)
          $discount
            .find(selectors.cartDiscountAmount)
            .html(
              theme.Currency.formatMoney(
                discount.total_allocated_amount,
                theme.moneyFormat,
              ),
            )
          return $discount[0]
        }.bind(this),
      )
    },

    _createLineItemList: function(state) {
      return $.map(
        state.items,
        function(item, index) {
          const $item = this.$itemTemplate.clone()
          const $itemPriceList = this.$itemPriceListTemplate.clone()
          this._setLineItemAttributes($item, item, index)
          this._setLineItemImage($item, item.featured_image)

          $(selectors.cartItemTitle, $item)
            .text(item.product_title)
            .attr('href', item.url)

          const productDetailsList = this._createProductDetailsList(
            item.product_has_only_default_variant,
            item.options_with_values,
            item.properties,
          )
          this._setProductDetailsList($item, productDetailsList)

          this._setItemRemove($item, item.title)

          $itemPriceList.html(
            this._createItemPrice(
              item.original_price,
              item.final_price,
              this.$itemPriceListTemplate,
            ),
          )

          this._setItemPrice($item, $itemPriceList)

          const itemDiscountList = this._createItemDiscountList(item)
          this._setItemDiscountList($item, itemDiscountList)

          this._setQuantityInputs($item, item, index)

          const itemLinePrice = this._createItemPrice(
            item.original_line_price,
            item.final_line_price,
            this.$itemLinePriceTemplate,
          )
          this._setItemLinePrice($item, itemLinePrice)

          return $item[0]
        }.bind(this),
      )
    },

    _setLineItemAttributes: function($item, item, index) {
      $item
        .attr(attributes.cartItemKey, item.key)
        .attr(attributes.cartItemUrl, item.url)
        .attr(attributes.cartItemVariantId, item.id)
        .attr(attributes.cartItemProductId, item.variant_id)
        .attr(attributes.cartItemTitle, item.title)
        .attr(attributes.cartItemIndex, index + 1)
        .attr(attributes.cartItemQuantity, item.quantity)
    },

    _setLineItemImage: function($item, featuredImage) {
      const $image = $(selectors.cartItemImage, $item)

      const sizedImageUrl =
        featuredImage.url !== null
          ? theme.Images.getSizedImageUrl(featuredImage.url, 'x190')
          : null

      if (sizedImageUrl) {
        $image
          .attr('alt', featuredImage.alt)
          .attr('src', sizedImageUrl)
          .removeClass(classes.hide)
      } else {
        $image.remove()
      }
    },

    _setProductDetailsList: function($item, productDetailsList) {
      const $itemDetails = $(selectors.cartItemDetails, $item)

      if (productDetailsList.length === 0) {
        $itemDetails.addClass(classes.hide).text('')
      } else {
        $itemDetails.removeClass(classes.hide).html(productDetailsList)
      }
    },

    _setItemPrice: function($item, price) {
      $(selectors.cartItemPrice, $item).html(price)
    },

    _setItemDiscountList: function($item, discountList) {
      const $itemDiscountList = $(selectors.cartItemDiscountList, $item)

      if (discountList.length === 0) {
        $itemDiscountList.html('').addClass(classes.hide)
      } else {
        $itemDiscountList.html(discountList).removeClass(classes.hide)
      }
    },

    _setItemRemove: function($item, title) {
      $(selectors.cartRemove, $item).attr(
        'aria-label',
        theme.strings.removeLabel.replace('[product]', title),
      )
    },

    _setQuantityInputs: function($item, item, index) {
      $(selectors.quantityInputDesktop, $item)
        .attr('id', 'updates_large_' + item.key)
        .attr(attributes.quantityItem, index + 1)
        .val(item.quantity)

      $(selectors.quantityLabelDesktop, $item).attr(
        'for',
        'updates_large_' + item.key,
      )
    },

    setQuantityFormControllers: function() {
      if (this.mql.matches) {
        $(selectors.quantityInputDesktop).attr('name', 'updates[]')
      } else {
        $(selectors.quantityInputDesktop).removeAttr('name')
      }
    },

    _setItemLinePrice: function($item, price) {
      $(selectors.cartItemLinePrice, $item).html(price)
    },

    _createProductDetailsList: function(
      product_has_only_default_variant,
      options,
      properties,
    ) {
      let optionsPropertiesHTML = []

      if (!product_has_only_default_variant) {
        optionsPropertiesHTML = optionsPropertiesHTML.concat(
          this._getOptionList(options),
        )
      }

      if (properties !== null && Object.keys(properties).length !== 0) {
        optionsPropertiesHTML = optionsPropertiesHTML.concat(
          this._getPropertyList(properties),
        )
      }

      return optionsPropertiesHTML
    },

    _getOptionList: function(options) {
      return $.map(
        options,
        function(option) {
          const $optionElement = this.$itemOptionTemplate.clone()

          $optionElement.text(option.value).removeClass(classes.hide)

          return $optionElement[0]
        }.bind(this),
      )
    },

    _getPropertyList: function(properties) {
      const propertiesArray =
        properties !== null ? Object.entries(properties) : []

      return $.map(
        propertiesArray,
        function(property) {
          const $propertyElement = this.$itemPropertyTemplate.clone()

          // Line item properties prefixed with an underscore are not to be displayed
          if (property[0].charAt(0) === '_') return

          // if the property value has a length of 0 (empty), don't display it
          if (property[1].length === 0) return

          $propertyElement
            .find(selectors.cartItemPropertyName)
            .text(property[0])

          if (property[0].indexOf('/uploads/') === -1) {
            $propertyElement
              .find(selectors.cartItemPropertyValue)
              .text(': ' + property[1])
          } else {
            $propertyElement
              .find(selectors.cartItemPropertyValue)
              .html(
                ': <a href="' +
                  property[1] +
                  '"> ' +
                  property[1].split('/').pop() +
                  '</a>',
              )
          }

          $propertyElement.removeClass(classes.hide)

          return $propertyElement[0]
        }.bind(this),
      )
    },

    _createItemPrice: function(original_price, final_price, $priceTemplate) {
      if (original_price !== final_price) {
        const $discountedPrice = $(
          selectors.cartItemDiscountedPriceGroup,
          $priceTemplate,
        ).clone()

        $(selectors.cartItemOriginalPrice, $discountedPrice).html(
          theme.Currency.formatMoney(original_price, theme.moneyFormat),
        )
        $(selectors.cartItemFinalPrice, $discountedPrice).html(
          theme.Currency.formatMoney(final_price, theme.moneyFormat),
        )
        $discountedPrice.removeClass(classes.hide)

        return $discountedPrice[0]
      } else {
        const $regularPrice = $(
          selectors.cartItemRegularPriceGroup,
          $priceTemplate,
        ).clone()

        $(selectors.cartItemRegularPrice, $regularPrice).html(
          theme.Currency.formatMoney(original_price, theme.moneyFormat),
        )

        $regularPrice.removeClass(classes.hide)

        return $regularPrice[0]
      }
    },

    _createItemDiscountList: function(item) {
      return $.map(
        item.line_level_discount_allocations,
        function(discount) {
          const $discount = this.$itemDiscountTemplate.clone()
          $discount
            .find(selectors.cartItemDiscountTitle)
            .text(discount.discount_application.title)
          $discount
            .find(selectors.cartItemDiscountAmount)
            .html(
              theme.Currency.formatMoney(discount.amount, theme.moneyFormat),
            )
          return $discount[0]
        }.bind(this),
      )
    },

    _showQuantityErrorMessages: function(itemElement) {
      $(selectors.cartQuantityErrorMessage, itemElement).text(
        theme.strings.quantityMinimumMessage,
      )

      $(selectors.cartQuantityErrorMessageWrapper, itemElement).removeClass(
        classes.hide,
      )

      $(selectors.quantityInput, itemElement)
        .addClass(classes.inputError)
        .focus()
    },

    _hideQuantityErrorMessage: function() {
      const $errorMessages = $(
        selectors.cartQuantityErrorMessageWrapper,
      ).addClass(classes.hide)

      $(selectors.cartQuantityErrorMessage, $errorMessages).text('')

      $(selectors.quantityInput, this.$container).removeClass(classes.inputError)
    },

    _handleThumbnailClick: function(evt) {
      const url = $(evt.target)
        .closest(selectors.cartItem)
        .data('cart-item-url')

      if (!url) {
        return
      }

      window.location.href = url
    },

    _hideCartError: function() {
      $(selectors.cartErrorMessageWrapper).addClass(classes.hide)
      $(selectors.cartErrorMessage).text('')
    },

    /**
     * Build and return a payload for Bloomreach.
     * @param {String} cartAction - Action related to the cart (remove/qty)
     * @param {String} key - Cart item line item key.
     * @param {Number} [newQty] - Quantity of new line item (only if cartAction is quantity)
     * @returns {Object}
     */
    _getBloomreachCartPayload: function(cartAction, key, newQty) {
      const data = {}

      if (!Object.keys(this.cartData).length) {
        return data
      }

      /**
       * Build products.
       */
      data.product_list = this.cartData.items
        .map(item => {
          let quantity = Number(item.quantity)

          if (cartAction === 'remove' && key === item.key) {
            return false
          }

          if (cartAction === 'quantity' && key === item.key) {
            quantity = newQty
          }

          return {
            product_id: Number(item.product_id),
            product_qty: Number(quantity),
            sku: item.sku,
          }
        })
        .filter(Boolean)

      data.product_details = this.cartData.items
        .map(item => {
          let quantity = Number(item.quantity)

          if (cartAction === 'remove' && key === item.key) {
            return false
          }

          if (cartAction === 'quantity' && key === item.key) {
            quantity = Number(newQty)
          }

          return {
            image_url: item.image,
            product_id: Number(item.product_id),
            item_qty: quantity,
            sku: item.sku,
            price: Number(item.price / 100),
            title: item.title,
            variant_id: Number(item.variant_id),
          }
        })
        .filter(Boolean)

      /**
       * Build core data.
       * - Build new Quantity and Price based on filters.
       */
      let totalPrice = 0
      let totalQuantity = 0

      data.product_details.forEach(product => {
        totalPrice += product.price
        totalQuantity += product.item_qty
      })

      data.currency = this.cartData.currency;
      (data.total_price = this.cartData.total_price / 100),
      (data.total_quantity = Number(totalQuantity))

      return data
    },

    /**
     * Handles the removal of a product from the cart.
     * - Typically used in themes 'Ajax mode'
     * - Non ajax-mode just has a /cart/change link
     * - For Bloomreach, hijack click event and submit data.
     * @param {Event} evt - Click event
     */
    _onRemoveItem: function(evt) {
      if (mint.services.bloomreach || mint.services.attraqt.tracking.enabled) {
        let data = {}

        const button = evt.target.closest(selectors.cartRemove)
        const lineItemKey = button.getAttribute('data-cart-remove') || ''

        if (!lineItemKey) {
          return
        }

        const matchingLineItem = this.cartData?.items?.find(item => {
          return item.key === lineItemKey
        })

        const product_id = Number(matchingLineItem.product_id)

        if (mint.services.bloomreach) {
          data = {
            ...data,
            ...this._getBloomreachCartPayload('remove', lineItemKey),
          }

          const modified = {
            price: Number(matchingLineItem.price / 100),
            product_id,
            variant_id: Number(matchingLineItem.variant_id),
          }

          data = {
            action: 'remove',
            ...data,
            ...modified,
          }

          mint.EventBus.dispatch('bloomreach:trackEvent', {
            event: 'cart_update_web',
            data,
          })
        }

        if (mint.services.attraqt.tracking.enabled) {
          mint.EventBus.dispatch('attraqt:trackEvent', {
            action: 'remove-from-cart',
            target: {
              product: `${product_id}`,
            },
          })
        }
      }
    },

    _emptyCart: function() {
      this.$emptyPageContent =
        this.$emptyPageContent ||
        $(selectors.emptyPageContent, this.$container)
      this.$cartWrapper =
        this.$cartWrapper || $(selectors.cartWrapper, this.$container)

      $(selectors.emptyPageContent).removeClass(classes.hide)
      $(selectors.cartWrapper).addClass(classes.hide)
    },

    _cartTermsConditions: function() {
      if ($('.cart__submit-controls .product__terms-conditions').length) {
        const checkBox = $(
          '.cart__submit-controls .product__terms-conditions input[type="checkbox"]',
        )

        checkBox.each(function() {
          if ($(this).prop('checked')) {
            $(this)
              .parents('.cart__submit-controls')
              .find('.btn--checkout')
              .removeClass('disabled')
          } else {
            $(this)
              .parents('.cart__submit-controls')
              .find('.btn--checkout')
              .addClass('disabled')
          }
        })

        $(document).on(
          'click',
          '.cart__submit-controls .product__terms-conditions .title',
          function(event) {
            event.preventDefault()
            const self = $(this),
              ipt = self.prev()

            if (!ipt.prop('checked')) {
              ipt.prop('checked', true)
              self
                .parents('.cart__submit-controls')
                .find('.btn--checkout')
                .removeClass('disabled')
            } else {
              ipt.prop('checked', false)
              self
                .parents('.cart__submit-controls')
                .find('.btn--checkout')
                .addClass('disabled')
            }
          },
        )
      }
    },

    cookiesEnabled: function() {
      let cookieEnabled = navigator.cookieEnabled

      if (!cookieEnabled) {
        document.cookie = 'testcookie'
        cookieEnabled = document.cookie.indexOf('testcookie') !== -1
      }
      return cookieEnabled
    },

    _cartCountDown: function() {
      if (!$('.cart__count_down').length) return

      let timer,
        elCountDown = $('.cart__count_down .count_down'),
        minute = elCountDown.data('time')

      function startTimer(duration, display) {
        timer = duration
        let minutes, seconds
        setInterval(function() {
          minutes = parseInt(timer / 60, 10)
          seconds = parseInt(timer % 60, 10)

          minutes = minutes < 10 ? '0' + minutes : minutes
          seconds = seconds < 10 ? '0' + seconds : seconds

          display.textContent = minutes + ':' + seconds

          if (--timer < 0) {
            timer = duration
          }
        }, 1000)
      }

      window.addEventListener("DOMContentLoaded", () =>  {
        (fiveMinutes = 60 * minute),
        (display = document.querySelector('#time'))
        startTimer(fiveMinutes, display)
      })
    },
  })

  return Cart
})()
